import React from "react";
import "./BuyerRequestSuggestion.scss";
import searchIcon from "../Home/img/search.png";

// Shown only when there's an active ORDINARY-search query with weak/no
// results — navigates to the existing /create-search page (manual "wanted"
// listing creation, a separate entity from Cvanto AI Search's Buyer
// Request flow — see CvantoAISearchModal.js's own no-results state, which
// deliberately does NOT reuse this component). Untouched by Phase 7 per
// the brief's explicit "don't touch the ordinary non-AI empty state" note.
const BuyerRequestSuggestion = ({ onAction }) => {
  return (
    <div className="buyer-request-suggestion buyer-request-suggestion--card">
      <div className="buyer-request-suggestion__icon">
        <img src={searchIcon} alt="" />
      </div>

      <div className="buyer-request-suggestion__text">
        <div className="buyer-request-suggestion__title">Не знайшли саме те?</div>
        <div className="buyer-request-suggestion__subtitle">
          Створіть запит — продавці та спеціалісти зможуть відгукнутися.
        </div>
      </div>

      <button
        type="button"
        className="buyer-request-suggestion__cta"
        onClick={onAction}
      >
        Створити запит
      </button>
    </div>
  );
};

export default BuyerRequestSuggestion;
